export const portDefaults = {
  baudRate: 9600,
  dataBits: 7,
  stopBits: 2,
  parity: "even",
  rts: true,
  dtr: true,
  handshake: "xOnXOff",
};
